module.exports = __webpack_public_path__ + "img/expo2024_wide.64a8b97.png";